import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Article from "@/pages/Article";
import Journal from "@/pages/Journal";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/admin/AuthContext";
import ProtectedRoute from "@/admin/ProtectedRoute";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminArticles from "@/admin/AdminArticles";
import AdminArticleEditor from "@/admin/AdminArticleEditor";
import AdminContent from "@/admin/AdminContent";
import AdminSubscribers from "@/admin/AdminSubscribers";
import AdminMedia from "@/admin/AdminMedia";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<Article />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="articles" element={<AdminArticles />} />
              <Route path="articles/new" element={<AdminArticleEditor />} />
              <Route path="articles/:slug/edit" element={<AdminArticleEditor />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="subscribers" element={<AdminSubscribers />} />
              <Route path="media" element={<AdminMedia />} />
            </Route>
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
